import config from '../config';
import moment from 'moment';

export default function getPackagesDownloads(packagesIds) {
    const currentDate = moment().format('YYYY-MM-DD');
    const yearBackDate = moment().subtract(364, 'days').format('YYYY-MM-DD');
    return fetch(`${config.npm.apiBaseURL}/downloads/range/${yearBackDate}:${currentDate}/${packagesIds.join(',')}`);
}